(() => {
    const initializeStarumiProductActions = () => {
        const bar = document.querySelector('[data-starumi-product-sticky-actions]');
        const form = bar?.closest('form[data-type="add-to-cart-form"]');
        const originalAdd = form?.querySelector('[data-btn-addtocart]');
        const addButton = bar?.querySelector('[data-starumi-product-add]');
        const buyNowButton = form?.querySelector('[data-starumi-product-buy-now]');
        const termsCheckbox = form?.querySelector('.global-checkbox--input');

        if (!bar || !form || !originalAdd || !addButton || !buyNowButton || bar.dataset.actionsReady === 'true') return;
        bar.dataset.actionsReady = 'true';

        const showError = (message) => {
            if (window.halo?.showWarning) {
                window.halo.showWarning(message);
            } else {
                window.alert(message);
            }
        };

        const termsAccepted = () => {
            if (!termsCheckbox || termsCheckbox.checked) return true;
            termsCheckbox.focus({ preventScroll: false });
            showError(termsCheckbox.labels?.[0]?.textContent?.trim() || 'Please accept the terms and conditions.');
            return false;
        };

        const canSubmit = () => {
            if (!form.checkValidity()) {
                form.reportValidity();
                return false;
            }
            if (originalAdd.disabled || originalAdd.getAttribute('aria-disabled') === 'true') return false;
            return termsAccepted();
        };

        const syncState = () => {
            const unavailable = originalAdd.disabled || originalAdd.getAttribute('aria-disabled') === 'true';
            const loading = originalAdd.classList.contains('is-loading');
            const disabled = unavailable || loading;
            addButton.disabled = disabled;
            buyNowButton.disabled = disabled;
            addButton.setAttribute('aria-busy', String(loading));
            buyNowButton.setAttribute('aria-busy', String(loading));

            const originalText = originalAdd.textContent.trim().toUpperCase();
            addButton.textContent = unavailable && originalText ? originalText : 'ADD TO CART';
        };

        addButton.addEventListener('click', () => {
            if (!canSubmit()) return;
            addButton.disabled = true;
            originalAdd.click();
            window.setTimeout(syncState, 0);
        });

        const stateObserver = new MutationObserver(syncState);
        stateObserver.observe(originalAdd, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'], childList: true, subtree: true });
        form.addEventListener('change', syncState);
        form.addEventListener('input', syncState);
        syncState();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeStarumiProductActions, { once: true });
    } else {
        initializeStarumiProductActions();
    }

    document.addEventListener('shopify:section:load', initializeStarumiProductActions);
})();
